import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_477: DocMigration = {
  maxSchemaVersion: "0.0.477",
  description: "Remove height and heightType fields from vaulted ceilings",
  apply(json: any) {
    if (!json.ceilings) {
      return json;
    }

    const { ceilings } = json;
    const ceilingIds = Object.keys(ceilings);

    for (const ceilingId of ceilingIds) {
      const ceiling = ceilings[ceilingId];
      if (ceiling.type === "VAULTED" || ceiling.type === "NONE") {
        if (ceiling.hasOwnProperty("height")) {
          delete ceiling.height;
        }
        if (ceiling.hasOwnProperty("heightType")) {
          delete ceiling.heightType;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_477;
